@if (form && showVariantOptions) {
  <div class="memory-variants">
    <div class="options-title">Lagringskapasitet</div>
    <div class="options-container">
      @for (memorySize of memorySizes; track memorySize.value) {
        <app-ice-radio-button
          ngDefaultControl
          testId="memory-size-input"
          [disabled]="memorySize.disabled"
          [forId]="memorySize.value"
          [formControlName]="MobilePhoneFormControls.Memory"
          [isBoxVersion]="true"
          [label]="memorySize.value"
          [value]="memorySize.value"
        />
      }
    </div>
  </div>
}
@if (form && showVariantOptions) {
  <div class="color-variants">
    <div class="options-title">Farge</div>
    <div class="options-container">
      @for (color of colors; track color.value) {
        <app-ice-radio-button
          ngDefaultControl
          testId="color-input"
          [disabled]="color.disabled"
          [forId]="color.value"
          [formControlName]="MobilePhoneFormControls.Color"
          [isBoxVersion]="true"
          [label]="color.value"
          [value]="color.value"
        />
      }
    </div>
  </div>
}
<ng-container *appAllowSettings="[DealerClaimType.CanSellHardwareWithLogistics]">
  @if (selectedVariant?.quantityInStock !== undefined) {
    @if (variantStockInfo) {
      <span class="stock-info-container">
        <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
        <span>{{ variantStockInfo }}</span>
      </span>
    } @else if (canBeBackOrdered) {
      <span class="backorder-info-container">
        <mat-icon [svgIcon]="IconNames.ice_clock" />
        {{ selectedVariant.backorderInfo.text }}
      </span>
    }
  } @else {
    <app-spinner size="medium" />
  }
</ng-container>
